import React from 'react';
import { Search, Edit2, Plus } from 'lucide-react';

/**
 * Compact URL bar shown after analysis completes
 * Replaces the full input form to save space and focus on results
 * 
 * @param {Object} props
 * @param {string} props.url - The analyzed URL
 * @param {Function} props.onEdit - Handler for edit button
 * @param {Function} props.onNewAnalysis - Handler for new analysis button
 */
function CompactURLBar({ url, onEdit, onNewAnalysis }) {
    return (
        <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-4 mb-8 transition-all hover:shadow-md animate-in fade-in slide-in-from-top-2 duration-300">
            <div className="flex items-center justify-between gap-4 flex-wrap">
                {/* Left: URL Display */}
                <div className="flex items-center gap-3 flex-1 min-w-0">
                    <div className="flex-shrink-0 p-2 bg-primary-50 rounded-lg">
                        <Search className="w-5 h-5 text-primary-600" />
                    </div>
                    <div className="flex-1 min-w-0">
                        <div className="text-xs font-medium text-slate-500 mb-1">Analyzed URL</div>
                        <div
                            className="text-sm text-slate-700 truncate font-medium"
                            title={url}
                        >
                            {url}
                        </div>
                    </div>
                </div>

                {/* Right: Action Buttons */}
                <div className="flex gap-2 flex-shrink-0">
                    <button
                        onClick={onEdit}
                        className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-slate-700 bg-slate-100 hover:bg-slate-200 rounded-lg transition-colors"
                    >
                        <Edit2 className="w-4 h-4" />
                        <span className="hidden sm:inline">Edit</span>
                    </button>
                    <button
                        onClick={onNewAnalysis}
                        className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-primary-600 hover:bg-primary-700 rounded-lg transition-colors shadow-sm hover:shadow"
                    >
                        <Plus className="w-4 h-4" />
                        <span className="hidden sm:inline">New Analysis</span>
                    </button>
                </div>
            </div>
        </div>
    );
}

export default CompactURLBar;
